// @flow

/**
 * Converts given object to a URL encoded string, suitable to
 * be passed as a part of the URL
 * @param  {Object} params
 * @return {String}
 */
const objectToQueryString = (params: Object = {}) => {
  const query = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join('&')
  return query ? `?${query}` : ''
}

export default objectToQueryString
